<template>
  <div class="social-proof">
    <div class="d-flex">
      <AvatarItem
        v-for="(img, index) in avatarImages"
        :key="index"
        :src-path="img"
      />
    </div>
    <div class="rating-info">
      <banner-stars :count="5" />
      <div>Loved by 100,000+ Teachers</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import AvatarItem from "@/components/global/onboardBanner/socialProof/avatar-item.vue";
import BannerStars from "@/components/global/onboardBanner/socialProof/banner-stars.vue";

const avatarImages = [
  "avatars/client1.png",
  "avatars/client2.png",
  "avatars/client3.png",
];

export default defineComponent({
  components: { BannerStars, AvatarItem },
  data() {
    return {
      avatarImages: avatarImages,
    };
  },
});
</script>

<style scoped lang="scss">
.social-proof {
  display: flex;
  align-items: center;
  gap: 8px;

  .rating-info {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    font-weight: var(--typography-font-weight-fw-600);
    letter-spacing: -0.5px;
    color: var(--color-text-on-surface-secondary);
  }
}
</style>
